import React from 'react';
import CopyableListInput from './CustomInputAndTitle';
import { useTranslation } from 'react-i18next';
const CustomEropaSection =({boxNumber})=>{
    const {t} = useTranslation()
    return(
        <div>
           <CopyableListInput label={t( "FullName")}
           title='Markaship e.U'
           />
           <CopyableListInput label={t( "Name")}
           title='Markaship'
           />
           <CopyableListInput label={t("Surname")}
           title='e.U.'
           />
           <CopyableListInput label={t( "City")}
           title='Austria'
           />
           <CopyableListInput
           label={t( "Province")}
           title='Vienna'
           />
           <CopyableListInput label={t( "PostalCode")}
           title='1100'
           />
           <CopyableListInput label={t( "FullAddress")}
            title={`Van-der-Nüll-Gasse 24/16 - Vienna / Austria ${boxNumber ? ` - Box: ${boxNumber}` : ''}`}
           />
           <CopyableListInput label={t( "CompanyName")}
           title='Markaship e.U.'
           />
           <CopyableListInput label={t("PhoneNumber")} 
           title='4367762009102'
           />
           <CopyableListInput label={t("TaxCircle") }
           title='08 5250850'
           />
           <CopyableListInput label={t("TaxNumber")}
           title='08 5250850'
           />

        </div>
    )
}

export default CustomEropaSection;